export const CH_EVENTS_ANALYTICS_PATH = '/2/httpapi';
export const CH_EVENTS_EXPERIMENT_PATH = '/experiment';

export function getChEventsAnalyticsUrl(proxyBaseUrl: string): string {
    return `${proxyBaseUrl}${CH_EVENTS_ANALYTICS_PATH}`;
}

export function getChEventsExperimentUrl(proxyBaseUrl: string): string {
    return `${proxyBaseUrl}${CH_EVENTS_EXPERIMENT_PATH}`;
}
